// material UI Components
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Onboarding from "../../onboarding";
// footerStyles
import footerStyles from "./footer.module.scss";

export const Footer = (): JSX.Element => {
  const [modalVisible, setModalVisible] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={footerStyles.container}>
      <div onClick={() => setModalVisible(true)}>
        <a className={footerStyles.link}>{t("lbl_footer_button_know_more")}</a>
      </div>
      <div className={footerStyles.link_container} />
      <div>
        <a
          href="https://waffyapp.com/terms-of-service-ar/"
          target="_blank"
          className={footerStyles.link}
          rel="noreferrer">
          {t("lbl_profile_settings_terms")}
        </a>
      </div>
      <Modal
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <div className={footerStyles.onboarding_container}>
          <Onboarding />
        </div>
      </Modal>
    </div>
  );
};
